import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import ApiContext from '@/context/ApiContext/ApiContext';
import HealthStatusContext from '@/context/HealthStatusContext/HealthStatusContext';

import { Language } from '../patients/types';

interface IUseGetMe {
  data: Array<Language>;
  isPending: boolean;
}

const useGetSupportedLocales = (enabled = true): IUseGetMe => {
  const { client } = useContext(ApiContext);
  const { areSystemsAvailable } = useContext(HealthStatusContext);
  const placeholderData = [Language.DE, Language.FR];

  const { data, isPending } = useQuery<Array<Language> | undefined, AxiosError>(
    {
      queryKey: ['api', 'mhp-web', 'me', 'supported-locales'],
      queryFn: async ({ queryKey }) => {
        const result = (
          await client.current?.get<Array<Language>>(queryKey.join('/'))
        )?.data;
        return result;
      },
      enabled: areSystemsAvailable && !!client.current && enabled,
      staleTime: 30 * 60 * 1000, // 30 minutes
      placeholderData,
    }
  );

  return { data: data ?? placeholderData, isPending };
};

export default useGetSupportedLocales;
